"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AlertType;
(function (AlertType) {
    AlertType[AlertType["Error"] = 1] = "Error";
    AlertType[AlertType["Success"] = 2] = "Success";
})(AlertType || (AlertType = {}));
exports.default = AlertType;
